import React, { useEffect, useState } from "react";
import Cards from "react-credit-cards-2";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { getDefaultPayment, updatePayment } from "../../slices/thunks";

import "react-credit-cards-2/dist/lib/styles.scss";
import { CardHeader, Col, Row } from "reactstrap";
import { Card } from "@mui/material";
import Loader from "../../Components/Common/Loader";
import { getLoggedinUser } from "../../utils/StorageManager";

const PaymentMethods = () => {
  const dispatch = useDispatch();

  const user = getLoggedinUser() || {};

  const selectBillingData = createSelector(
    (state) => state.Billing,
    (subscriptionPayment) => subscriptionPayment,
    (purchasePayment) => purchasePayment,
    (loading) => loading
  );

  // Inside your component
  const { subscriptionPayment, purchasePayment, loading } =
    useSelector(selectBillingData);

  useEffect(() => {
    dispatch(getDefaultPayment());
  }, []);
  /*
  useEffect(() => {
    console.log("Subscription Payment: ", subscriptionPayment);
    console.log("Purchase Payment: ", purchasePayment);
  }, [subscriptionPayment, purchasePayment]);
*/
  const updatePaymentMethod = async (type) => {
    const data = {
      pmtype: type,
    };
    dispatch(updatePayment(data));
  };

  return (
    <div>
      <h4>Payment Methods</h4>
      {!user.user_free && (
        <Row className="mb-4">
          <Col xl={3} sm={12}>
            <Card className="mb-4 pb-4 justify-content-center">
              <CardHeader className="bg-light p-3 mb-4">
                <h5>Subscription Payment</h5>
                <button
                  onClick={() => {
                    updatePaymentMethod(0);
                  }}
                  className="btn btn-primary "
                >
                  {subscriptionPayment ? "Update " : "Create "} Subscription
                  Payment Method
                </button>
              </CardHeader>
              {loading ? (
                <Loader />
              ) : subscriptionPayment ? (
                <Cards
                  number={`${
                    subscriptionPayment?.issuer === "amex"
                      ? "**** ****** *" + subscriptionPayment?.last4
                      : "**** **** **** " + subscriptionPayment?.last4
                  }`}
                  expiry={`${
                    subscriptionPayment?.expMonth < 10
                      ? "0" + subscriptionPayment?.expMonth
                      : subscriptionPayment?.expMonth
                  }/${subscriptionPayment?.expYear}`}
                  name={subscriptionPayment?.name}
                  preview={true}
                  issuer={
                    subscriptionPayment?.issuer === "amex"
                      ? "american-express"
                      : subscriptionPayment?.issuer
                  }
                />
              ) : (
                <h5 className="text-center">
                  <i className="fas fa-credit-card"></i>
                  No payment method found
                </h5>
              )}
              <br />
            </Card>
          </Col>
        </Row>
      )}
      <Row>
        <Col xl={3} sm={12}>
          <Card className="mb-4 pb-4 justify-content-center">
            <CardHeader className="bg-light p-3 mb-4">
              <h5>Product Purchases Payment</h5>
              <button
                onClick={() => {
                  updatePaymentMethod(1);
                }}
                className="btn btn-primary"
              >
                {purchasePayment ? "Update " : "Create "} Purchase Payment
                Method
              </button>
            </CardHeader>
            {loading ? (
              <Loader />
            ) : purchasePayment ? (
              <Cards
                number={`${
                  subscriptionPayment?.issuer === "amex"
                    ? "**** ****** *" + subscriptionPayment?.last4
                    : "**** **** **** " + subscriptionPayment?.last4
                }`}
                expiry={`${
                  purchasePayment?.expMonth < 10
                    ? "0" + purchasePayment?.expMonth
                    : purchasePayment?.expMonth
                }/${purchasePayment?.expYear}`}
                name={purchasePayment?.name}
                preview={true}
                issuer={
                  subscriptionPayment?.issuer === "amex"
                    ? "american-express"
                    : subscriptionPayment?.issuer
                }
              />
            ) : (
              <h5 className="text-center">
                <i className="fas fa-credit-card"></i>
                No payment method found
              </h5>
            )}
            <br />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentMethods;
